
import { Injectable } from '@angular/core';
import { DataProvider,ParameterService,Widget,DashboardConfigManager,AuthService,LogService,GroupedBarChartObject, KeyValue,GroupedBarChartObjectCollection  } from "core-dashboard";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Subscription, timer, forkJoin, Observable, of as observableOf } from "rxjs";
import { map, delay, catchError } from "rxjs/operators";


@Injectable()
export class GroupedBarchartProvider implements DataProvider {

    widget: Widget;
    config: any;
    private configUrl = "configs/GroupedBarChartTestData.json";
    totalCount = 'TotalCount';
    unprocessedCount = 'UnprocessedCount';
    widgetDrawn: boolean = false;
    private timer;
    private subscription: Subscription;
    defaultinterval: number = 30;
    pointArray: any[] = [];
    pointName: string;
    objectValueUrl = '/api/propertyvalues/';
    private dpName: string = "";
    data: any;
    private groups: any;

    constructor(private authService: AuthService,
        private parameterService: ParameterService,
        private http: HttpClient,
        private loggerHelper: LogService,
        private dashboardConfig: DashboardConfigManager) {
        this.data = {};
    }
    //this is to get reduced COV data if required
    getReducedCovData(tData:any){

    }
    getData(w: Widget) {

        this.widget = w;
        this.config = this.widget.getConfig();
        try {

            if (this.config == undefined) {
                this.loggerHelper.logWarning("GroupedBarchartProvider", " Config is missing in widget setup.");
                this.widget.Draw(null);
                return;
            }

            if (this.authService.HasValidSSO() && this.authService.HasValidToken() === false) {
                this.authService.LoginWithSSO().subscribe(
                    (response:HttpResponse<any>) => {
                        if (response) {
                            this.GetEventCounters();
                        }
                    }, error => {
                        //this code will get executed when base URL path is inccorrect
                        this.loggerHelper.logWarning("GroupedBarchartProvider", "GroupedBarchartProvider is not able to login!");
                        this.widget.Draw(null);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.GetEventCounters();
            } else {
                this.loggerHelper.logWarning("GroupedBarchartProvider", "GroupedBarchartProvider is not able to login!");
                this.widget.Draw(null);
            }
        }
        catch (error) {
            this.loggerHelper.logError('GroupedBarchartProvider', "Error while fetching data. Error:" + error);
            this.widget.Draw(null);
        }
    }

     // this will zoom the widget
     zoom(zoomFrom: any, zoomTo: any) {       
    }


    private StartTimer(widget: Widget) {
        let interval = 1;
        if (this.config.pollingInterval != undefined)
            interval = this.config.pollingInterval;
        else
            interval = this.defaultinterval;

        var timerintervale = interval * 1000;
        this.timer = timer(timerintervale, timerintervale);
        this.subscription = this.timer.subscribe((t:HttpResponse<any>) => this.callback(widget));
    }

    callback(widget: Widget) {
        this.getData(widget);
    }


    private GetEventCounters() {

        this.GetObjectValue().then(x => {
            if (!this.widgetDrawn) {
                this.loggerHelper.logInfo("GroupedBarchartProvider", "Call for drawing widget is initiated");
                this.widget.Draw(this.data);
                this.widgetDrawn = true;
                this.StartTimer(this.widget);
            } else {
                this.loggerHelper.logInfo("GroupedBarchartProvider", "Call for drawing widget is initiated");
                this.widget.Update(this.data);
            }
        }).catch(error => {
            //TODO:
            // this section of code was part of processError() method
            //because widget and loggerhelper are losing their references , moving code to inline method
            //this needs more investigation and code refactor
            let errMsg: any = (error && error.message) ? error.message : "Server error";
            if (this.loggerHelper)
                this.loggerHelper.logError("GroupedBarchartProvider", "Error in received from service: " + errMsg);
            if (this.widget)
                this.widget.Draw(null);
        });


        // let baseUrl = this.dashboardConfig.getBaseUrl();
        // let url: string = this.configUrl;
        // let counterType = this.config.counterType;


        // this.http.get(url).subscribe(res => {
        //     try {
        //         this.loggerHelper.logInfo("GroupedBarchartProvider", "Response received from service : " + res);
        //         if (res.status < 200 || res.status >= 300) {
        //             throw new Error("Bad response status: " + res.status);
        //         }
        //         let body: any = res.json();

        //         //create data collection
        //         if (body) {
        //             let data: GroupedBarChartObject[] = [];
        //             for (var i = 0; i < body.length; i++) // event counter's array 
        //             {
        //                 let obj: GroupedBarChartObject = {
        //                     Category: body[i].Category,
        //                     Values: body[i].Values
        //                 };
        //                 data.push(obj);
        //             }
        //             this.loggerHelper.logInfo("GroupedBarchartProvider", "Call for drawing widget is initiated");

        //             if (!this.widgetDrawn) {
        //                 this.widget.Draw(data);
        //                 this.widgetDrawn = true;
        //                 this.StartTimer(this.widget);
        //             }
        //             else
        //                 this.widget.Update(data)
        //         }
        //     }
        //     catch (error) {
        //         this.loggerHelper.logError('GroupedBarchartProvider', "Error while processing response for counterType " + counterType + "Error: " + error);
        //     }
        // }, (error) => {
        //     //TODO:
        //     // this section of code was part of processError() method
        //     //because widget and loggerhelper are losing their references , moving code to inline method
        //     //this needs more investigation and code refactor
        //     let errMsg: any = (error && error.message) ? error.message : "Server error";
        //     if (this.loggerHelper)
        //         this.loggerHelper.logError("GroupedBarchartProvider", "Error in received from service: " + errMsg);
        //     if (this.widget)
        //         this.widget.Draw(null);
        // });
    }

    private processError(error: any) {

    }

    public ngOnDestroy(): void {
        this.dispose();
    }

    private GetObjectValue() {
        this.pointArray = this.parameterService.getParameter("points").split(',');
        this.groups = this.parameterService.getParameter("groups") ? parseInt(this.parameterService.getParameter("groups")) : 2;
        let forkJoins: Observable<any>[] = [];
        var provider = this;
        this.data.ResponseArrayCollection = [];
        if (this.pointArray && this.pointArray.length > 0) {
            let promise: Promise<void> = new Promise<void>(function (resolve) {
                provider.pointArray.forEach(point => {
                    let baseUrl = provider.dashboardConfig.getBaseUrl();
                    let pName = point;
                    let url: string = baseUrl + provider.objectValueUrl + pName;
                    let counterType = provider.config.counterType;

                    //get token
                    let token: any = provider.authService.getToken();// window.sessionStorage.getItem("_token");
                    let headers: HttpHeaders = new HttpHeaders({"Accept": "application/json","Authorization":"Bearer " + token,"Access-Control-Allow-Origin": "*"});
                    //headers.append("Accept", "application/json");
                    //headers.append("Access-Control-Allow-Origin", "*");
                    //headers.append("Authorization", "Bearer " + token);
                    provider.loggerHelper.logInfo("GroupedBarchartProvider", "Calling WSI API");
                    forkJoins.push(provider.http.get(url, {
                        headers: headers
                    }).pipe(map(data => data)//.json()
                   // , catchError(error => Observable.of(error)))
                ));
                   // delay(500)
                       // .map(data => data.json())
                     //   );

                });
                forkJoin(forkJoins).subscribe(result => {
                    provider.loggerHelper.logInfo("GroupedBarchartProvider", "Received response.");
                    var x = 0;
                    var y = provider.groups;
                    var k = 0;
                    var counter: number = 0;
                    var categryCounter: number = 1;
                    var categories = Math.floor(provider.pointArray.length / provider.groups) + 1;
                    var keyValArray: Array<KeyValue> = [];
                    for (let i = 0; i < provider.pointArray.length; i++) {
                        if (result[i].status && result[i].status != 200) {
                            provider.loggerHelper.logError("GroupedBarchartProvider", "Unable to get data for " + provider.pointArray[i]);

                        } else {
                            let body: any = result[i];
                            if (counter == y) {
                                x = x + 1;
                                counter = 0;
                                categryCounter++;
                            }
                            counter++;


                            var category = "H" + x;
                            //create data collection
                            if (body && body.Properties && body.Properties[0] != null) {
                                var property = body.Properties[0];

                                var value: KeyValue =
                                    {
                                        Key: "V-L" + k+"-N",
                                        Value: property.Value.QualityGood == true ? parseFloat(property.Value.Value) : 0,
                                        Unit: undefined,
                                        Resolution:0
                                    }
                                keyValArray.push(value);
                                var obj: GroupedBarChartObject;
                                obj = {
                                    Category: category,
                                    Values: keyValArray,
                                };
                                k++;
                                if (k == y || (categryCounter == categories && i == (provider.pointArray.length - 1))) {
                                    provider.data.ResponseArrayCollection.push(obj);
                                    provider.data.DataPointName = undefined;
                                    provider.data.xAxisLabel = "X-Axis";
                                    provider.data.yAxisLabel = "Y-Axis";
                                    k = 0;
                                    keyValArray = [];
                                }

                            }
                        }
                    }
                    resolve();
                }, error => {
                    //TODO:
                    // this section of code was part of processError() method
                    //because widget and loggerhelper are losing their references , moving code to inline method
                    //this needs more investigation and code refactor
                    let errMsg: any = (error && error.message) ? error.message : "Server error";
                    if (this.loggerHelper)
                        this.loggerHelper.logError("GroupedBarchartProvider", "Error in received from service: " + errMsg);
                    if (this.widget)
                        this.widget.Draw(null);
                })
            })
            return promise;
        }
    }

    dispose(): void {
        try {
            if (this.subscription)
                this.subscription.unsubscribe();
            if (this.loggerHelper)
                this.loggerHelper.logInfo("GroupedBarchartProvider", "GroupedBarchartProvider disposed");
        }
        catch (error) {
            if (this.loggerHelper)
                this.loggerHelper.logError("GroupedBarchartProvider", "error while dispoing dataprovider, " + error);
        }

    }
}